import * as yup from 'yup';

// Validation schema for editing salary allowance percentages
export const createEditSalaryAllowanceSchema = (isOnDemandPayEnabled: boolean) => {
  const baseSchema = {
    globalAllowancePercentageType: yup.string().required('Please select a global limit option'),
    globalAllowancePercentageCustom: yup.string().when('globalAllowancePercentageType', {
      is: 'CUSTOM',
      then: (schema) =>
        schema
          .required('Custom global limit is required')
          .test('whole-number', 'Custom global limit must be a whole number', (value) => {
            const num = parseInt(value || '0', 10);
            return !Number.isNaN(num) && Number.isInteger(num);
          })
          .test('range', 'Custom global limit must be between 0 and 50', (value) => {
            const num = parseInt(value || '0', 10);
            return num >= 0 && num <= 50;
          }),
      otherwise: (schema) => schema.notRequired(),
    }),
  };

  if (isOnDemandPayEnabled) {
    return yup.object().shape({
      ...baseSchema,
      odpAllowancePercentageType: yup
        .string()
        .required('Please select an ODP sub-limit option')
        .test(
          'odp-less-than-global',
          'On-demand pay sub-limit must be below or equal to the global limit',
          function validateOdpLessThanGlobal(value) {
            const {
              globalAllowancePercentageType,
              globalAllowancePercentageCustom,
              odpAllowancePercentageCustom,
            } = this.parent;

            if (!value || !globalAllowancePercentageType) return true;

            // If global allowance is not set yet, skip validation
            if (globalAllowancePercentageType === undefined) return true;

            // Calculate final ODP value
            const odpValue: number =
              value === 'CUSTOM'
                ? parseInt(odpAllowancePercentageCustom || '0', 10)
                : parseInt(value, 10);

            // Calculate final global value
            const globalValue: number =
              globalAllowancePercentageType === 'CUSTOM'
                ? parseInt(globalAllowancePercentageCustom || '0', 10)
                : parseInt(globalAllowancePercentageType, 10);

            return odpValue <= globalValue;
          }
        ),
      odpAllowancePercentageCustom: yup.string().when('odpAllowancePercentageType', {
        is: 'CUSTOM',
        then: (schema) =>
          schema
            .required('Custom ODP sub-limit is required')
            .test('whole-number', 'Custom ODP sub-limit must be a whole number', (value) => {
              const num = parseInt(value || '0', 10);
              return !Number.isNaN(num) && Number.isInteger(num);
            })
            .test('range', 'Custom ODP sub-limit must be between 0 and 50', (value) => {
              const num = parseInt(value || '0', 10);
              return num >= 0 && num <= 50;
            }),
        otherwise: (schema) => schema.notRequired(),
      }),
    });
  }

  return yup.object().shape(baseSchema);
};

export interface EditSalaryAllowanceFormData {
  globalAllowancePercentageType?: string;
  globalAllowancePercentageCustom?: string;
  odpAllowancePercentageType?: string;
  odpAllowancePercentageCustom?: string;
}
